import { createFileRoute } from '@tanstack/react-router';

import { ScenarioLandingPage } from '@/features/author-scenario/components/scenario-landing-page';

export const Route = createFileRoute('/scenario/$scenarioSlug')({
  component: ScenarioRoute,
});

function ScenarioRoute() {
  const { scenarioSlug } = Route.useParams();

  return <ScenarioLandingPage scenarioSlug={scenarioSlug} />;
}
